import React, { useState, useEffect } from 'react';
import ScrollInfo from '../UI/ScrollInfo/ScrollInfo';
import classes from './Fanolly.module.scss';
import FanollyContents from './FanollyContents/FanollyContents';
import './svg.scss';
import snapklarkVideo from '../../assets/snaplark_video_null.mp4';
import lShape1 from '../../assets/L1.svg';
import lShape2 from '../../assets/L2.svg';
import fireImg from '../../assets/images/Fanolly/fire-icon@1.5x.png';
import sumofameImg from '../../assets/images/Fanolly/sumofame-logo@1.5x.png'
import sumoBg1 from '../../assets/images/Fanolly/how-bg@1.5x.png';
import sumoBg2 from '../../assets/images/Fanolly/red-bg@1.5x.png';
import sumoIcon from '../../assets/images/Fanolly/sumo-icon-1.png';
import arrowImg from '../../assets/images/Fanolly/arrow.png';
import cloud1 from '../../assets/images/Fanolly/1.png';
import cloud2 from '../../assets/images/Fanolly/2.png';
import cloud3 from '../../assets/images/Fanolly/3.png';
import cloud4 from '../../assets/images/Fanolly/4.png';
import cloud5 from '../../assets/images/Fanolly/5.png';

const clouds = [cloud1, cloud2, cloud3, cloud4, cloud5];
const randClouds = [];
const randClouds2 = [];
for (let i=0; i<Math.max(1, window.innerWidth / (240 + 450 + 20) + 1); i++) {
  for (let j=0; j<Math.max(1, window.innerHeight / 350); j++) {
    if (Number.parseInt(Math.random() * 5) === 2) {
      break;
    }
    randClouds.push({
      index: Number.parseInt(Math.random() * clouds.length),
      x: (450 * (i+1) + (100 * (j%2))) + (Math.random() * 20) - 10,
      y: (340 * j + (50 * (i%2))) + (Math.random() * 20) - 10
    });
    randClouds2.push({
      index: Number.parseInt(Math.random() * clouds.length),
      x: (550 * (i+1) + (100 * (j%2))) + (Math.random() * 20) - 10,
      y: (350 * j + (50 * (i%2))) + (Math.random() * 20) - 10
    });
  }
}
const setRandArrows = () => {
  // let pX=0, pY=0;
  let lY = null;
  const arr = [];
  for (let i=0; i<Math.max(20, window.innerWidth / (70) + 1); i++) {
    if (lY !== null) {
      if (lY > 300 && lY < window.innerHeight - 250) {
        const y1 = Math.random() * (lY - 250) + 25;
        const y2 = Math.random() * (lY + 250) - 25 + window.innerHeight/2;
        lY = Math.random() * 2 < 1 ? y1 : y2;
      }
      else if (lY > 300) {
        lY = Math.random() * (lY - 250) + 25;
      }
      else {
        lY = Math.random() * (lY + 250) - 25 + window.innerHeight/2;
      }
    }
    else {
      lY = Math.random() * (window.innerHeight - 50) + 25;
    }
    console.log('lY :>> ', lY);
    arr.push({ x: (240 + 100) * i, y: lY, fire: Math.random() * 2 < 1 });
  }
  return arr;
}
// const arrows = setRandArrows();
// const arrows2 = setRandArrows();
// const arrowArr = Array.apply(null, new Array(Math.max(2, Number.parseInt(window.innerWidth / (180)))))
//     .map((v, i) => ({ x: (240 + 100) * i, y: Math.random() * (window.innerHeight - 50) + 25 }));
const arrowArr = setRandArrows();

// for (let i=0; i<Math.max(1, window.innerWidth / (240 + 350 + 20) + 1); i++) {
//   for (let j=0; j<Math.max(1, window.innerHeight / 150); j++) {
//     arrows.push({
//       x: (350 * i + 50) + (Math.random() * 20) - 10,
//       y: (200 * j + 100) + (Math.random() * 50) - 25
//     })
//   }
// }

const items = [
  // {name: 'SNAPLARK', colors: ['#E66A75', '#FCCACB', '#FFDCDC']},
  {name: 'SNAPLARK', colors: ['#3093FF', '#aadaff', '#3093FF', '#FFFFFF']},
  // {name: 'FANOLLY', colors: ['#42503F', '#F2F276', '#D9E021']},
  {name: 'FANOLLY', colors: ['#FFFFFF', '#999999', '#010101', 'url(#linear)']},
  // {name: 'SUMOFAME', colors: ['#FFFF01', '#1BB3CB', '#21C5EA']}
  {name: 'SUMOFAME', colors: ['#ed181f', '#FFFFFF', '#21C5EA', '#ed181f']}
];

const Fanolly = ({ maskSize, setMaskSize, isMobile }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [transX, setTransX] = useState(0);
  const [animEnd, setAnimEnd] = useState(false);

  useEffect(()=> {
    if (transX > 50) {
      document.body.classList.add('scrollable');
      document.body.style = 'overflow: hidden';
    } 
    else {
      document.body.classList.remove('scrollable');
      document.body.style = 'overflow: auto';
    } 
  }, [transX]);

  const moveContents = (left)=> {
    if (left && transX < 50) setTransX(100);
    else if (!left && transX > 50) setTransX(0);
  }

  return (
    <div className={classes.Fanolly} style={{
      // backgroundColor: items[activeIndex].colors[2]
    }}>
      <div className={classes.MainBg}>
        <div className={[classes.SnaplarkBg, activeIndex === 0 ? classes.Active:''].join(' ')}>
          <div className={classes.Video}
            dangerouslySetInnerHTML={{ __html: `
              <video loop autoPlay muted autobuffer>
                <source src="${snapklarkVideo}" type="video/mp4" />
                <source src="${require('../../assets/snaplark_video_null.mp4')}" type="video/mp4" />
                Your browser does not support the video tag. I suggest you upgrade your browser.
              </video>            
            `}}
          ></div>
          {/* <video className={classes.Video} autoPlay loop>
              <source src={snapklarkVideo} type='video/mp4' />
          </video> */}
          <div className={classes.Black}></div>
        </div>

        <div className={[classes.FanollyBg, activeIndex === 1 ? classes.Active:''].join(' ')}>
          <div className={classes.Shapes}>
            <img src={lShape1} alt="L" className={[classes.Image, classes.Image1].join(' ')} />
            <img src={lShape2} alt="L" className={[classes.Image, classes.Image2].join(' ')} />
          </div>
        </div>

        <div className={[classes.SumofameBg, activeIndex === 2 ? classes.Active:''].join(' ')}>
          <div className={classes.Black}></div>
          <div className={classes.Clouds}>
          
            <div className={classes.Clouds1}>
              {randClouds.map((cloud, i) => (
                <img src={clouds[cloud.index]} key={i} alt="C" className={classes.Cloud} style={{
                  left: cloud.x + 'px',
                  top: cloud.y + 'px'
                }} />
              ))}
            </div>
            <div className={classes.Clouds2}>
              {randClouds2.map((cloud, i) => (
                <img src={clouds[cloud.index]} key={i} alt="C" className={classes.Cloud} style={{
                  left: cloud.x + 'px',
                  top: cloud.y + 'px'
                }} />
              ))}
            </div>
            <div className={classes.Clouds3}>
              {randClouds.map((cloud, i) => (
                <img src={clouds[cloud.index]} key={i} alt="C" className={classes.Cloud} style={{
                  left: cloud.x + 'px',
                  top: cloud.y + 'px'
                }} />
              ))}
            </div>
            <div className={classes.Clouds4}>
              {randClouds2.map((cloud, i) => (
                <img src={clouds[cloud.index]} key={i} alt="C" className={classes.Cloud} style={{
                  left: cloud.x + 'px',
                  top: cloud.y + 'px'
                }} />
              ))}
            </div>

          </div>
          
          <div className={classes.Arrows}>

            {arrowArr.map((item, i) => {
              const firstX = arrowArr[0].x;
              const lastX = arrowArr[arrowArr.length -1].x;
              const maxX = lastX + item.x;
              {/* const speedP = lastX / maxX * 100; */}
              const v = lastX / 8000;
              const dur = maxX / v;
              {/* console.log('dur: ', dur, (firstX/ item.x)); */}
              /* if (item.x > window.innerWidth - 240) {
                return null;
              } */
              return (
                <div key={i} className={classes.Arrow} style={{
                    top: item.y + 'px',
                    // left: item.x + 'px'
                    // transform: `translate(${item.x}px, ${y}px)`
                    "--x": item.x + 'px',
                    "--y": item.y + 'px',
                    "--maxX": lastX + 240 + 100 + 'px',
                    "--dur": dur + 'ms',
                    // animationDuration: dur + 'ms'
                    animationDelay: 1800 * i + 'ms'
                }} >
                  <img src={arrowImg} alt="A" className={classes.ArrowImg} />

                  {item.fire && <img src={fireImg} alt="F" className={classes.Fire} />}
                </div>
              ) 
            })}

          </div>

          <img src={sumofameImg} alt="S" className={classes.MainLogo} />
          <img src={sumoIcon} alt="I" className={classes.SumoIcon} />
          <img src={sumoBg1} alt="BG" className={[classes.BottomBg, classes.Bg1].join(' ')} />
          <img src={sumoBg2} alt="BG" className={[classes.BottomBg, classes.Bg2].join(' ')} />
        
        </div>
      </div>

      {/* <img src={bgSvg} alt="BG" className={classes.Bg} /> */}

      {/* <ScrollInfo small={isMobile} parentClass={classes.Fanolly} color={items[activeIndex].colors[0]}>E-Preneur</ScrollInfo> */}
      <ScrollInfo small={isMobile} 
        parentClass={classes.Fanolly} 
        color={items[activeIndex].colors[activeIndex === 0 && transX > 50 ? 3 : 0]}
        grad={activeIndex === 1 && transX < 50}
        clicked={transX > 50 ? ()=> moveContents(false) : null}  
      >
        {transX < 50 ? "Entrepreneur" : "Go back to main page"}
      </ScrollInfo>

      <div className={classes.Contents} style={{
        transform: `translateX(-${transX}%)`
      }}>
        <svg className={classes.BgSvg} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" stroke={items[activeIndex].colors[3]}
          viewBox="0 0 474.9 784" style={{ enableBackground: "new 0 0 474.9 784"}} xmlSpace="preserve">
            <defs>
              <linearGradient id="linear" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%"   stopColor="#F8DA76"/>
                <stop offset="90%" stopColor="#A26427"/>
                <stop offset="100%" stopColor="#EDA64B"/>
              </linearGradient>
            </defs>
        <g id="Layer_2_1_">
          <g id="Layer_1-2">
            <text transform="matrix(6.123234e-17 -1 1 6.123234e-17 216.81 783.4609)" className="st0 st1 st2">&lt;E-p</text>
            <text transform="matrix(6.123234e-17 -1 1 6.123234e-17 216.81 228.9004)" className="st0 st1 st2 st3">r</text>
            <text transform="matrix(6.123234e-17 -1 1 6.123234e-17 216.81 136.9805)" className="st0 st1 st2">e</text>
            <text transform="matrix(6.123234e-17 -1 1 6.123234e-17 419.81 564.3096)" className="st0 st1 st2">neur</text>
          </g>
        </g>
        </svg>

        {items.map((item, i) => {
          const classNames = [classes.Item];
          const styles = {
            color: items[activeIndex].colors[1]
          };
          if (i === activeIndex) {
            styles.color = item.colors[0];
            classNames.push(classes.Active);
          } 
          if (activeIndex === 2) classNames.push(classes.Dim);

          return (
            <h1 className={classNames.join(' ')} key={i} style={styles}
              onMouseEnter={()=> i !== activeIndex ? setActiveIndex(i) : 0}
              onClick={()=> {
                moveContents(true);
                if (i !== activeIndex) setActiveIndex(i)
              }}
            >{item.name}</h1>
          );
        })}
      </div>

      <FanollyContents contents={items} activeIndex={activeIndex}
        onBack={()=> moveContents(false)}
        animEnd={animEnd}
        setAnimEnd={setAnimEnd}
        setActiveIndex={setActiveIndex} style={{
        transform: `translateX(-${transX}%)`
      }} />
    </div>
  );
}

export default Fanolly;